import Modal from "modal-react-native-web"
import React, { useMemo, useState } from "react"
import {
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native"
import { Overlay } from "react-native-elements"
import Icon from "react-native-vector-icons/AntDesign"
import Material from "react-native-vector-icons/MaterialCommunityIcons"
import { useDispatch, useSelector } from "react-redux"
import { useMediaQuery } from "react-responsive"

import Base, { Actions, Api } from "../../../../base"
import base from "../../../../base"
import Functions from "../../../../base/Functions"
import { Alert, LoadingView } from "../../../common"
import Gap from "../../../common/Gap"
import ItemRow from "./ItemRow"
import MenuCategory from "./MenuCategory"
import MenuHeader from "./MenuHeader"
import MenuItem from "./MenuItem"

function menuHeader(navigation, headerTitle) {
  return {
    ...Base.constants.headerOptions(false, headerTitle),
    headerLeft: () => (
      <TouchableOpacity
        style={Base.styles.headerButton}
        onPress={() => navigation.goBack()}
      >
        <Icon name="arrowleft" size={24} color="white" />
      </TouchableOpacity>
    ),
  }
}

export default function MenuDetailsScreen(props) {
  const itemId = props.route.params.itemId ?? null
  const service = useSelector(state => state.service)
  const item = useMemo(() => Functions.getMenuItemById(service?.menu, itemId), [
    itemId,
    service,
  ])

  const itemName = useMemo(() => item?.name ?? "", [item])

  const stack = [...(props.route.params.stack ?? []), itemName]
  const [loading, setLoading] = useState(null)
  const isMobile = useMediaQuery(Base.constants.mobile)
  const dispatch = useDispatch()
  props.navigation.setOptions(menuHeader(props.navigation, itemName))

  function itemPressed(t) {
    if (t.price) {
      props.navigation.push("MenuDetails", { item: t, stack, itemId: t._id })
      return
    }
  }

  const isFlooid = useMemo(() => service?.menu?.provider === "Flooid", [
    service,
  ])

  async function onStockChange(_item, status) {
    try {
      setLoading("Updating Stock...")

      const success = await Api.updateMenuStock(_item, status)

      if (!success || success === null) {
        Alert.show(
          "Hold Up!",
          "Unable to update this item at the moment, please check your connection and try again.",
          "OK",
          () => {
            setLoading(null)
          },
        )
        return
      }
      const menu = Base.functions.toggleItemValue(
        service.menu,
        _item._id,
        "inStock",
        status,
      )
      dispatch(Actions.setService({ ...service, menu }))
      setLoading(null)
    } catch (error) {
      console.log(error)
    }
  }

  async function onStatusChange(_item, status) {
    try {
      setLoading("Updating Status...")
      const success = await Api.updateMenuStatus(_item, status)

      if (!success || success === null) {
        Alert.show(
          "Hold Up!",
          "Unable to update this item at the moment, please check your connection and try again.",
          "OK",
          () => {
            setLoading(null)
          },
        )
        return
      }

      const key =
        _item.__type === "MenuItem"
          ? isFlooid
            ? "active"
            : "isActive"
          : "enabled"

      const menu = Base.functions.toggleItemValue(
        { ...service.menu },
        _item._id,
        key,
        status,
      )
      dispatch(Actions.setService({ ...service, menu }))
      setLoading(null)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <View style={styles.container}>
      <ScrollView
        style={[isMobile ? styles.main : styles.main_lg]}
        showsVerticalScrollIndicator={false}
      >
        <MenuHeader stack={stack} isMobile={isMobile} item={item} />
        <View>
          {!Base.functions.menuItemHasContent(item) && (
            <View style={styles.error}>
              <Material
                name="food-off"
                size={150}
                color={base.colours.appSemiLightGrey}
              />
              <Text style={styles.errorText}>No menu items to display</Text>
            </View>
          )}
          {(item?.items ?? []).map(_item => (
            <ItemRow
              key={_item._id}
              static={true}
              item={_item}
              onStockChange={onStockChange}
              onStatusChange={onStatusChange}
              onPress={itemPressed}
              isFlooid={isFlooid}
            />
          ))}

          {(item?.subCategories ?? item?.categories ?? []).map(category => (
            <MenuCategory
              key={category._id}
              category={category}
              onStockChange={onStockChange}
              onStatusChange={onStatusChange}
              onPress={itemPressed}
              isFlooid={isFlooid}
            />
          ))}
          {item?.price && (
            <MenuItem
              item={item}
              onStockChange={onStockChange}
              onStatusChange={onStatusChange}
              isFlooid={isFlooid}
            />
          )}
        </View>
        <Gap size={24} />
      </ScrollView>
      {Platform.OS === "web" ? (
        <Modal animationType="fade" transparent={true} visible={!!loading}>
          <LoadingView title={loading} />
        </Modal>
      ) : (
        <Overlay
          isVisible={!!loading}
          windowBackgroundColor="#00000097"
          overlayStyle={styles.overlay}
          animationType={"fade"}
          statusBarTranslucent={"true"}
        >
          <LoadingView title={loading} />
        </Overlay>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: { flex: 1 },
  main: {
    flex: 1,
    marginHorizontal: Base.constants.hmargin.sm,
  },

  main_lg: {
    flex: 1.0,
    marginHorizontal: Base.constants.hmargin.lg * 1.5,
  },

  header: {
    flexDirection: "row",
    alignItems: "flex-end",
    height: 80,
  },

  errorText: {
    fontFamily: Base.fonts.appExtraBold,
    color: Base.colours.appSemiLightGrey,
    fontSize: 25,
    marginTop: 20,
  },

  error: {
    marginTop: 100,
    alignItems: "center",
  },
  overlay: {
    backgroundColor: "transparent",
    shadowOpacity: 0,
    elevation: 0,
  },
})
